import { render, staticRenderFns } from "./AITestResponse.vue?vue&type=template&id=48c6eb20&scoped=true&"
import script from "./AITestResponse.vue?vue&type=script&lang=js&"
export * from "./AITestResponse.vue?vue&type=script&lang=js&"
import style0 from "./AITestResponse.vue?vue&type=style&index=0&id=48c6eb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6eb20",
  null
  
)

export default component.exports